const Listar = () => import('../views/Listar')
const routes = [
    {
        name: 'listarNfxeEmissor',
        path: '/emissor/notas_fiscais_consumidores',
        alias: ['/emissor/notas_fiscais_consumidores/index'],
        component: Listar,
    },
]

export default routes
